import request from '@/utils/request'

// 查询审核任务分页
export function pageCommunityPostAudit(query) {
  return request({
    url: '/biz/admin/community/community/post/audit/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询审核违规帖子列表
export function listViolationCommunityPostAudit() {
  return request({
    url: '/biz/admin/community/community/post/audit/violation/list',
    method: 'post',
    headers: { 'repeatSubmit': false }
  })
}

// 删除违规帖子
export function deleteViolationCommunityPost(data) {
  return request({
    url: '/biz/admin/community/community/post/audit/delete/post',
    method: 'post',
    data: data
  })
}
